
import { combineReducers } from 'redux';
import * as R from 'ramda';
import moment from 'moment';
import C from '../../../constants/customer-po/current/editCutTicket';

const rawData = (state = null, action) => {
  const { type, payload } = action;
  switch (type) {
    case C.SHOW_MODAL:
      return payload;
    default:
      return state;
  }
};

const cutTicketName = (state = '', action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_CUT_TICKET_NAME:
      return payload;
    case C.SHOW_MODAL:
      return R.path(['cutTicket'], payload);
    default:
      return state;
  }
};

const selectableStores = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_SELECTABLE_STORES:
      return payload;
    default:
      return state;
  }
};

const selectedStore = (state = null, action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_SELECTED_STORE:
      return payload;
    case C.SHOW_MODAL:
      return R.pathOr(null, ['store'], payload);
    default:
      return state;
  }
};

const selectedWarehouse = (state = null, action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_SELECTED_WAREHOUSE:
      return payload;
    case C.SHOW_MODAL: {
      const warehouse = R.pathOr(null, ['warehouse'], payload);
      return { ...warehouse, _id: warehouse.name };
    }
    default:
      return state;
  }
};

const selectableShipModes = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_SELECTABLE_SHIP_MODES:
      return payload;
    default:
      return state;
  }
}

const selectedShipMode = (state = null, action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_SELECTED_SHIP_MODE:
      return payload;
    case C.SHOW_MODAL:
      return R.pathOr(null, ['shipMode'], payload);
    default:
      return state;
  }
}

const mainLabel = (state = '', action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_MAIN_LABEL:
      return payload;
    case C.SHOW_MODAL:
      return R.pathOr('', ['mainLabel'], payload);
    default:
      return state;
  }
}

const ihDate = (state = moment().format(), action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_IH_DATE:
      return payload;
    case C.SHOW_MODAL:
      return R.pathOr('', ['ihDate'], payload);
    default:
      return state;
  }
}

const exFactory = (state = moment().format(), action) => {
  const { type, payload } = action;
  switch (type) {
    case C.SHOW_MODAL:
      return R.pathOr('', ['exFactory'], payload);
    default:
      return state;
  }
}

const note = (state = '', action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_NOTE:
      return payload;
    case C.SHOW_MODAL:
      return R.pathOr('', ['note'], payload);
    default:
      return state;
  }
}

const errors = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_CUT_TICKET_NAME:
      return {...state, 'cutTicket': !payload ? 'Please input cut ticket name' : null };
    case C.CHANGE_IH_DATE:
      return { ...state, 'ihDate': !payload ? 'Please input ih date': null};
    case C.CHANGE_SELECTED_SHIP_MODE:
      return { ...state, 'selectedShipMode': !payload ? 'Please select ship mode': null};
    case C.CHANGE_SELECTED_WAREHOUSE:
      return {...state, 'selectedWarehouse': !payload ? 'Please select warehouse': null};
    default:
      return state;
  }
}

const submiting = (state = false, action) => {
  const { type } = action;
  switch (type) {
    case C.SUBMIT:
      return true;
    case C.CANCEL_SUBMIT:
      return false;
    default:
      return state;
  }
}

const combined = combineReducers({
  rawData,
  cutTicketName,
  selectableStores,
  selectedStore,

  selectedWarehouse,

  selectableShipModes,
  selectedShipMode,

  mainLabel,
  ihDate,
  exFactory,
  note,

  errors,
  submiting,
});


export default (state, action) => {
  const { type } = action;
  if (type === C.RESET_DATA) {
    return {};
  }
  return combined(state, action);
};

